import { Suspense } from 'react';
import { useRoutes, BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import routes from './routes/routes';

function App() {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');

  const routing = useRoutes(routes(userData.id));

  return <>{routing} </>;
}

const AppWrapper = () => {
  return (
    <Router>
      <Suspense
        fallback={
          <div style={{ width: '100%', textAlign: 'center' }}>
            <div className="loader">Loading...</div>
          </div>
        }
      >
        <ToastContainer position="top-center" autoClose={2500} />
        <App />
      </Suspense>
    </Router>
  );
};

export default AppWrapper;
